import React from "react";
import * as c from "./iconSuccess.module.scss";
import classNames from "classnames";

export const IconSuccess = ({ className, ...props }) => {
  return (
    <svg className={classNames(className, c.checkmark)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
      <circle className={c.circle} cx="26" cy="26" r="25" fill="none" />
      <path className={c.check} fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
    </svg>
  );
};
